import { useEffect, useRef } from "react";

const qualifications = [
  {
    icon: "ri-broadcast-line",
    title: "第一級陸上無線技術士",
    description: "総務大臣指定試験（公益財団法人日本無線協会）",
    holders: 9,
  },
  {
    icon: "ri-shield-user-line",
    title: "職長・安全衛生責任者",
    description: "現場の安全管理と作業指揮を担う資格",
    holders: 10,
  },
  {
    icon: "ri-tools-line",
    title: "高所作業車運転技能講習",
    description: "高所作業車の安全な運転・操作に必要な技能講習",
    holders: 2,
  },
  {
    icon: "ri-car-line",
    title: "高所作業車運転特別教育",
    description: "高所作業車の運転に必要な特別教育修了",
    holders: 2,
  },
  {
    icon: "ri-shield-check-line",
    title: "フルハーネス特別教育",
    description: "高所作業時の墜落制止用器具に関する特別教育修了",
    holders: 12,
  },
];

export default function Qualifications() {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".qual-el").forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = "1";
                (el as HTMLElement).style.transform = "translateY(0)";
              }, i * 80);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="qualifications"
      ref={ref}
      className="py-24 relative overflow-hidden"
      style={{ background: "#0D2550" }}
    >
      {/* Decorative background elements */}
      <div
        className="absolute top-0 right-0 w-80 h-80 rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(0,119,204,0.08) 0%, transparent 70%)",
        }}
      />
      <div
        className="absolute bottom-0 left-0 w-64 h-64 rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(0,119,204,0.06) 0%, transparent 70%)",
        }}
      />

      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <p
            className="qual-el text-inexx-blue text-sm font-semibold tracking-widest uppercase mb-3 transition-all duration-500"
            style={{ opacity: 0, transform: "translateY(20px)" }}
          >
            QUALIFICATIONS
          </p>
          <h2
            className="qual-el text-3xl md:text-4xl font-bold mb-4 transition-all duration-500"
            style={{ opacity: 0, transform: "translateY(20px)", color: "#FFFFFF" }}
          >
            資格・実績
          </h2>
          <div
            className="qual-el mx-auto mt-2 mb-6 w-16 h-0.5 bg-inexx-blue transition-all duration-500"
            style={{ opacity: 0 }}
          />
          <p
            className="qual-el text-sm md:text-base leading-relaxed max-w-2xl mx-auto transition-all duration-500"
            style={{ opacity: 0, transform: "translateY(20px)", color: "#A8C0D6" }}
          >
            株式会社iNeXXのスタッフは、通信業界に必要な専門資格を保有しています。確かな技術力と安全管理のもと、高品質なサービスを提供しています。
          </p>
        </div>

        {/* Qualification Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {qualifications.map((q, i) => (
            <div
              key={i}
              className="qual-el rounded-2xl p-6 md:p-8 flex flex-col items-center text-center cursor-default"
              style={{
                opacity: 0,
                transform: "translateY(30px)",
                background: "#102B5C",
                border: "1px solid #1A3A70",
                boxShadow: "none",
                transition:
                  "opacity 0.5s ease, transform 0.5s ease, box-shadow 0.3s ease, border-color 0.3s ease",
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.boxShadow =
                  "0 8px 30px rgba(0,119,204,0.18)";
                (e.currentTarget as HTMLDivElement).style.borderColor =
                  "rgba(0,119,204,0.5)";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.boxShadow = "none";
                (e.currentTarget as HTMLDivElement).style.borderColor = "#1A3A70";
              }}
            >
              {/* Icon */}
              <div
                className="w-14 h-14 flex items-center justify-center rounded-full mb-5"
                style={{
                  background: "rgba(0,119,204,0.18)",
                  border: "1px solid rgba(0,119,204,0.4)",
                }}
              >
                <i className={`${q.icon} text-inexx-blue text-2xl`} />
              </div>

              {/* Title */}
              <h4
                className="font-bold mb-3 leading-snug"
                style={{ color: "#FFFFFF", fontSize: "16px" }}
              >
                {q.title}
              </h4>

              {/* Description */}
              <p className="text-sm leading-relaxed mb-5 flex-1" style={{ color: "#A8C0D6" }}>
                {q.description}
              </p>

              {/* Holders count */}
              <div
                className="w-full pt-5 mt-auto"
                style={{ borderTop: "1px solid #1A3A70" }}
              >
                <p className="text-xs mb-1" style={{ color: "#A8C0D6" }}>保持者数</p>
                <p
                  className="font-bold leading-none"
                  style={{ color: "#0077CC", fontSize: "28px" }}
                >
                  {q.holders}
                  <span className="text-base font-semibold ml-1" style={{ color: "#0077CC" }}>
                    名
                  </span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
